import { ACTION_TYPES } from "../actions/types";

const initialState = {
  healthData: null,
  healthLoading: false,
  healthError: null,
  lastUpdated: null,
  recoveries: [],
  recoveriesCount: 0,
};

export default function healthReducer(state = initialState, action) {
  switch (action.type) {
    case ACTION_TYPES.GET_SERVER_HEALTH:
      return {
        ...state,
        healthData: action.payload,
        lastUpdated: new Date().getTime(),
      };

    case ACTION_TYPES.SET_HEALTH_LOADING:
      return {
        ...state,
        healthLoading: action.payload,
      };

    case ACTION_TYPES.SET_HEALTH_ERROR:
      return {
        ...state,
        healthError: action.payload,
      };

    case ACTION_TYPES.GET_RECOVERIES:
      return {
        ...state,
        recoveries: action.payload.recoveries || [],
        recoveriesCount: action.payload.count || 0,
      };

    default:
      return state;
  }
}
